import { Permission } from "@/permissions/types";

export default function factory(permission): (...args: any[]) => Permission {
    return (...args: any[]) => {
        const permissionCreator = permission(...args);

        if (!permissionCreator.redirectRouteName) {
            permissionCreator.redirectRouteName = "403";
        }

        if (!permissionCreator.message) {
            permissionCreator.message =
                "Você não tem permissão para executar esta ação.";
        }

        return permissionCreator;
    };
}
